import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_2 = { class: "flex flex-col gap-6" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_managing_country_read_row = _resolveComponent("managing-country-read-row")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Title, {
      fontSize: 16,
      label: _ctx.$t('clientManagement.managementDetail.clientInfoTitle')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.newestUpdated.updatedAt) + " " + _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.by")) + " " + _toDisplayString(_ctx.newestUpdated.updatedByName), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        fontSize: 14,
        class: "w-10/12",
        label: _ctx.$t('clientManagement.managementDetail.clientType'),
        value: _ctx.detailData.clientType
      }, null, 8, ["label", "value"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.clientId'),
          value: _ctx.idClient
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-6/12",
          fontSize: 14,
          label: _ctx.$t('clientManagement.managementDetail.clientCode'),
          value: _ctx.detailData.clientCode
        }, null, 8, ["label", "value"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.parentClientName'),
          value: _ctx.detailData.clientName
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12 break-all",
          label: _ctx.$t('clientManagement.managementList.columns.alias'),
          value: _ctx.detailData.clientAlias
        }, null, 8, ["label", "value"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.clientCategory'),
          value: _ctx.detailData.clientCategory
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.companySize'),
          value: _ctx.detailData.clientCompanySize
        }, null, 8, ["label", "value"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.address'),
          value: _ctx.detailData.clientAddress
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.districtCity'),
          value: _ctx.detailData.clientDistrict?.name
        }, null, 8, ["label", "value"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.email'),
          value: _ctx.detailData.clientEmail
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.phone'),
          value: _ctx.formatPhoneNumber(_ctx.detailData.clientPhone)
        }, null, 8, ["label", "value"])
      ]),
      _createVNode(_component_DataWrapper, {
        fontSize: 14,
        label: _ctx.$t('clientManagement.managementDetail.needAssessmentChange'),
        value: _ctx.detailData.clientIsNeedAssessment ? _ctx.$t('clientManagement.managementDetail.yes') : _ctx.$t('clientManagement.managementDetail.no')
      }, null, 8, ["label", "value"]),
      _createVNode("div", null, [
        _createVNode(_component_managing_country_read_row, {
          value: _ctx.detailData.clientManagingCountryName || '-'
        }, null, 8, ["value"])
      ])
    ])
  ], 64))
}